import React, { useEffect, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { CircularProgress, Backdrop } from "@mui/material";

import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import { Theme } from "../../config/aws-exports";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import { HeadingPrimary } from "../../components/Styles/Heading";
import config from "../../config/aws-exports";
import { authData } from "../../redux/auth/authSlice";
import { API } from "aws-amplify";
import { Divider, Paper } from "@mui/material";
import Swal from "sweetalert2";
import moment from "moment";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";

const Calendar = () => {
  const localizer = momentLocalizer(moment);
  const userDetails = useSelector(authData);

  const [eventsRec, setEvents] = useState([]);
  const [upEvents, setupEvents] = useState([]);
  const [upSessions, setUpSessions] = useState([]);
  const [calendarLoader, setCalendarLoader] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEvents() {
    try {
      setCalendarLoader(true);
      const res = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getEvents",
        {
          body: {
            oid: config.aws_org_id,
            tenant: userDetails.tenant,
            eid: userDetails.username,
            st_id: userDetails?.uData?.st_id,
            schema: config.schema,
          },
        },
      );

      filterAll(res.events || [], res.session || []);
    } catch (error) {
      console.error(error);
      filterAll([], []);
    } finally {
      setCalendarLoader(false);
    }
  }

  function filterAll(eventsData, sessionsData) {
    let calendar = [];
    let upcomingEvents = [];
    let upcomingSessions = [];

    const now = new Date();

    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
    );

    const endOfRange = new Date(startOfToday);
    endOfRange.setDate(startOfToday.getDate() + 7);
    endOfRange.setHours(23, 59, 59, 999);

    eventsData.forEach((item) => {
      const startDate = new Date(parseInt(item.start));

      const eventObj = {
        title: item.title,
        start: startDate,
        end: startDate,
        description: item.desc,
        link: item.link,
        type: "event",
      };

      calendar.push(eventObj);

      if (startDate >= startOfToday && startDate <= endOfRange) {
        upcomingEvents.push(eventObj);
      }
    });

    sessionsData.forEach((session) => {
      session.date_list?.forEach((d) => {
        const startDate = new Date(d.combineStartTime);
        const endDate = new Date(d.combineEndTime);

        if (startDate >= startOfToday && startDate <= endOfRange) {
          let cleanDesc = session.sdesc || "";

          // ✅ decode HTML entities
          const txt = document.createElement("textarea");
          txt.innerHTML = cleanDesc;
          cleanDesc = txt.value;

          // ✅ remove junk tags
          cleanDesc = cleanDesc
            .replace(/<br\s*\/?>/gi, "")
            .replace(/<p>\s*<\/p>/gi, "")
            .trim();

          const sessionObj = {
            title: session.sn,
            start: startDate,
            end: endDate,
            description: cleanDesc,
            link: session.weblink,
            sid: session.sid,
            type: "session",

            // ✅ ADD THESE
            speakers: session.speakers || [],
            price: session.priceinr,
          };

          calendar.push(sessionObj);
          upcomingSessions.push(sessionObj);
        }
      });
    });

    upcomingEvents.sort((a, b) => a.start - b.start);
    upcomingSessions.sort((a, b) => a.start - b.start);

    setEvents(calendar);
    setupEvents(upcomingEvents);
    setUpSessions(upcomingSessions);
  }

  function EventOpen({ event }) {
    let content = "";

    // ✅ SESSION UI
    if (event.type === "session") {
      const speakerNames = event.speakers?.map((s) => s.name).join(", ");

      content = `
      <div>
        <p><strong>Speakers:</strong> ${speakerNames || "N/A"}</p>
        
${
  event.price
    ? `<p><strong>Price:</strong> INR ${event.price} (Inc. of GST)</p>`
    : ""
}

       
      </div>
    `;
    }

    // ✅ NON-SESSION UI
    else {
      content = `
      <div>
        <div><strong>Description: </strong>${event.description || ""}</div>
        ${
          event.link
            ? `<p><strong>Link: </strong>
                <a href="${event.link}" target="_blank"
                   style="word-break:break-all;">
                  ${event.link}
                </a>
              </p>`
            : " "
        }
      </div>
    `;
    }

    Swal.fire({
      title: event.title,

      html: `
      <div style="text-align:left; font-size:14px;">
        <h3 style="font-size:13px; margin:0 0 8px 0;"><strong>Date and Time:</strong>
          ${moment(event.start).format("DD-MM-YYYY hh:mm A")} 
          ${event.end ? " - " + moment(event.end).format("hh:mm A") : ""}
        </h3>
        ${content}
      </div>
    `,

      confirmButtonText: event.type === "session" ? "Go to session" : "OK",

      confirmButtonColor: "#F05A3C",
      showConfirmButton: true,

      showCancelButton: true,
      cancelButtonText: "Cancel",

      buttonsStyling: true,
      reverseButtons: false,

      didOpen: () => {
        const title = document.querySelector(".swal2-title");
        if (title) {
          title.style.fontSize = "18px";
          title.style.fontWeight = "600";
        }

        const btn = Swal.getConfirmButton();
        const cancelBtn = Swal.getCancelButton();
        if (btn) {
          btn.style.fontSize = "12px";
          btn.style.padding = "6px 12px";
          btn.style.borderRadius = "6px";
        }

        if (cancelBtn) {
          cancelBtn.style.fontSize = "12px";
          cancelBtn.style.padding = "6px 12px";
          cancelBtn.style.borderRadius = "6px";
          cancelBtn.style.marginRight = "8px"; // ✅ spacing
        }
      },
    }).then((result) => {
      if (result.isConfirmed && event.type === "session") {
        navigate(`/session?sid=${event.sid}`);
      }
    });
  }

  return (
    <Stack spacing={2} margin={2}>
      <Backdrop
        open={calendarLoader}
        sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1 })}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Stack direction={{ xs: "column", md: "row" }} spacing={4}>
        <Box sx={{ flex: 2 }}>
          <HeadingPrimary>Calendar</HeadingPrimary>

          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
            <Link to="/dashboard">Dashboard</Link>
            <Typography color={Theme.color.text}>Calendar</Typography>
          </Breadcrumbs>

          <Paper sx={{ p: 2 }}>
            <div style={{ height: 600 }}>
              <BigCalendar
                localizer={localizer}
                events={eventsRec}
                startAccessor="start"
                endAccessor="end"
                views={["month", "week", "day"]}
                popup
                onSelectEvent={(event) => EventOpen({ event })}
                eventPropGetter={(event) =>
                  event.type === "session"
                    ? {
                        style: {
                          backgroundColor: "#F05A3C",
                          color: "white",
                        },
                      }
                    : {}
                }
                style={{ height: 580 }}
              />
            </div>
          </Paper>
        </Box>

        <Box sx={{ flex: 1, minWidth: "320px" }}>
          <HeadingPrimary>Upcoming</HeadingPrimary>

          <Paper sx={{ p: 2, maxHeight: 650, overflowY: "auto" }}>
            <Typography fontWeight="bold" sx={{ mb: 2 }}>
              Events
            </Typography>

            {upEvents.length === 0 && (
              <Typography>No upcoming events</Typography>
            )}

            {upEvents.map((event, index) => (
              <React.Fragment key={index}>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  onClick={() => EventOpen({ event })}
                  sx={{ cursor: "pointer" }}
                >
                  <Box
                    sx={{
                      textAlign: "center",
                      background: Theme.color.secondary,
                      color: "white",
                      borderRadius: "8px",
                      px: 2,
                      py: 1,
                      minWidth: 60,
                    }}
                  >
                    <div style={{ fontSize: 12 }}>
                      {moment(event.start).format("ddd")}
                    </div>
                    <div style={{ fontSize: 18, fontWeight: "bold" }}>
                      {moment(event.start).format("DD")}
                    </div>
                  </Box>

                  <Box>
                    <Typography fontWeight="bold" sx={{ fontSize: "12px" }}>
                      {event.title}
                    </Typography>

                    <Box
                      sx={{ fontSize: "14px", color: "gray" }}
                      dangerouslySetInnerHTML={{
                        __html: event.description || "",
                      }}
                    />
                  </Box>
                </Stack>

                {index !== upEvents.length - 1 && <Divider sx={{ my: 2 }} />}
              </React.Fragment>
            ))}

            <Divider sx={{ my: 3 }} />

            <Typography fontWeight="bold" sx={{ mb: 2 }}>
              Sessions
            </Typography>

            {upSessions.length === 0 && <Typography>No sessions</Typography>}

            {upSessions.map((session, index) => (
              <React.Fragment key={index}>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  onClick={() => EventOpen({ event: session })}
                  sx={{ cursor: "pointer" }}
                >
                  <Box
                    sx={{
                      textAlign: "center",
                      background: "#F05A3C",
                      color: "white",
                      borderRadius: "8px",
                      px: 2,
                      py: 1,
                      minWidth: 60,
                    }}
                  >
                    <div style={{ fontSize: 12 }}>
                      {moment(session.start).format("ddd")}
                    </div>
                    <div style={{ fontSize: 18, fontWeight: "bold" }}>
                      {moment(session.start).format("DD")}
                    </div>
                  </Box>

                  <Box>
                    <Typography fontWeight="bold">{session.title}</Typography>

                    <Typography variant="body2" color="text.secondary">
                      {moment(session.start).format("hh:mm A")} -{" "}
                      {moment(session.end).format("hh:mm A")}
                    </Typography>
                  </Box>
                </Stack>

                {index !== upSessions.length - 1 && <Divider sx={{ my: 2 }} />}
              </React.Fragment>
            ))}
          </Paper>
        </Box>
      </Stack>
    </Stack>
  );
};

export default Calendar;
